export default __webpack_public_path__ + "static/media/taurus.a30de350.png";